import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtgjnec5vr: FaireProductEntity = {
  token: "p_wtgjnec5vr",
  type: "product",
  name: "Strawberry & Cherry Design Rhinestone Fruit Hair Clips",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/8d2a0f48447beffc05686b55d2fa06b74751128f89c7878e7e339ffc83f9d086.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03b58dcac209f2041352a41ed4d1dfeee1b95e3577775b250c5ad3ebfee9bf05.jpeg",
    "https://cdn.faire.com/fastly/87f9cff0b8072bc8cf2d98fc4455557f69edb2b3f901e02b69e22ec15d2cb694.jpeg",
    "https://cdn.faire.com/fastly/01af6a6adf047d3b748aa115a62c584c4b97ff17287af0b1b7db1575010c0555.jpeg",
    "https://cdn.faire.com/fastly/0f666b6bac3997b0a100d29a014823523aa25b21f0ac163e0d4f2ad516dbe205.jpeg",
    "https://cdn.faire.com/fastly/5bf5cfdbca21b17495cf03084eaf90fb31fa243697d521257826a3d2aaff767a.jpeg",
    "https://cdn.faire.com/fastly/0d9b5b5a2683ebcc4755bb19f07e4e6ae3a39b48967af931b0e3ec9cf8cdcd1a.jpeg",
    "https://cdn.faire.com/fastly/95187ebdfb7a5dc765aabce2b41b48ee83c7fd7b26f3d18afdc27d94e25bfbd3.jpeg",
    "https://cdn.faire.com/fastly/0d307b55836eaa9b108921ada39e7eb5f721141fa7abe1ac72c3efa926abecad.jpeg",
    "https://cdn.faire.com/fastly/05eefd0d096dea5b200c7f184334fab82ae83db10419c2840906290cdaab3855.jpeg",
  ],
  priceDollars: 5.13,
  description:
    "🌿 Material:  Acetate\n\n📏 Size & Weight: 10.5*5cm, 34g\n\n💖 Design Features:\nAdd a sweet, shiny touch to your hairstyles with these adorable fruit-themed claw clips! Featuring vibrant cherry and strawberry designs, each is dotted with sparkling rhinestones that catch the light for a playful, glamorous look. Crafted with a smooth, glossy beige base and sturdy claws, they hold hair (half-up styles, loose waves, or quick updos) securely while adding a cute, fruity accent to casual outings, brunch, or daily wear. Lightweight and eye-catching, these clips blend fun fruit aesthetics with everyday functionality—perfect for anyone who loves charming, shiny hair accessories.",
  tags: [],
  msrpDollars: 10.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:42.225Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
